import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userCreditEnrollmentColumns = [
    { field: 'enrollmentDatetime', name: 'Enrollment Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'enrollmentId', name: 'Enrollment Id', dataType: 'numeric' },
    {
        field: 'creditReportLastGeneratedDatetime',
        name: 'Last Report Date ({tz} time zone)',
        dataType: 'datetime',
    },
    {
        field: 'completedEnrollment',
        name: 'Enrollment Complete',
        dataType: 'boolean',
    },
];

const UserCreditEnrollment = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userCreditEnrollmentColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.enrollmentDatetime),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Enrollments',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="Credit Enrollments Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows user enrollment in the credit report feature. Each
                    row represents a user who has enrolled to access their credit report
                    data.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Enrollment Date">
                    The date when the user completed enrollment for the credit report
                    feature.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Enrollment Id">
                    A unique identifier assigned to each enrollment record.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Last Report Date">
                    The most recent date when a credit report was generated for this user.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Enrollment Complete">
                    Indicates whether the user has finished the enrollment process.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserCreditEnrollment;
